<mat-form-field>
  <input
    autocomplete="off"
    matInput
    placeholder="{{ placeholder | translate }}"
    type="email"
    name="email"
    email
    required
    #loginEmailInput="ngModel"
    (ngModelChange)="onInputChange()"
    [(ngModel)]="emailInput.emailAddress"
    [disabled]="disabled" />
  <mat-icon matSuffix [ngClass]="{ success: isValid() }">
    {{ isValid() ? "done" : "person" }}
  </mat-icon>
</mat-form-field>
